import React, { Component } from 'react'
import ComposeMessage from './ComposeMessage'
import LoadingData from '../../../../Components/Elements/Loading/LoadingData'
import ReadMessage from './ReadMessage'
import {
    Alert,
    Badge,
    Box,
    Button,
    Grid,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material'
import { Link } from 'react-router-dom'

import { faInbox } from '@fortawesome/pro-duotone-svg-icons/faInbox'
import { faPaperPlane } from '@fortawesome/pro-duotone-svg-icons/faPaperPlane'
import {
    faEnvelope,
    height,
} from '@fortawesome/pro-duotone-svg-icons/faEnvelope'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { faDownload } from '@fortawesome/pro-duotone-svg-icons/faDownload'
import { faFolderOpen } from '@fortawesome/pro-duotone-svg-icons/faFolderOpen'
import { faRectangleXmark } from '@fortawesome/pro-duotone-svg-icons/faRectangleXmark'
import { faArrowTurnLeft } from '@fortawesome/pro-duotone-svg-icons/faArrowTurnLeft'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Pagination from '@/Components/Elements/Pagination'
import ItemCounter from '@/Components/Elements/ItemCounter'
import MessagesReadstatus from './MessagesReadstatus'
import DOMPurify from 'dompurify'
import { faLink } from '@fortawesome/pro-duotone-svg-icons'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import MessageContent from './MessageContent'
import MessageBadges from './MessageBadges'
import MessagesHeader from './MessagesHeader'

class MessagesOverview extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentUrl: window.location.href,
            checkall: false,
            checked: [],
            compose: false,
            count: 0,
            filter: 'incoming',
            items: [],
            loading: false,
            limit: 20,
            page: 0,
            pager: [],
            showSuccess: false,
            search: '',
            selectedItemId: null,
            title: 'Inbox',
            showAdditionalContent: false,
            hoveredItemId: null,
            message: {},
            newMessage: false,
        }

        this.closeChangeReadStatus = this.closeChangeReadStatus.bind(this)
        this.fetchItems = this.fetchItems.bind(this)
        this.getButton = this.getButton.bind(this)
        this.getCheckedItems = this.getCheckedItems.bind(this)
        this.getBadges = this.getBadges.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.hasCheckedItem = this.hasCheckedItem.bind(this)
        this.newIncomingMessagesCounter =
            this.newIncomingMessagesCounter.bind(this)
        this.onChangePage = this.onChangePage.bind(this)
        this.resetButton = this.resetButton.bind(this)
        this.selectAll = this.selectAll.bind(this)
        this.setIncomingFilter = this.setIncomingFilter.bind(this)
        this.setOutgoingFilter = this.setOutgoingFilter.bind(this)
        this.archivedFilter = this.archivedFilter.bind(this)
        this.updateCheckedStatus = this.updateCheckedStatus.bind(this)
        this.getAndSetReadItem = this.getAndSetReadItem.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.resetSearch = this.resetSearch.bind(this)
        this.renderDetailMessage = this.renderDetailMessage.bind(this)
    }

    fetchItems(params = {}) {
        if (this.state.loading) {
            return
        }

        let filters = {
            filter: params.filter,
            limit: this.state.limit,
            page: this.state.page,
        }

        if (this.state.search !== null && this.state.search.length > 0) {
            filters.search = this.state.search
        }

        this.setState({ loading: true })

        const url = this.props.kedo.api().getMessageEndpoint()

        if (filters.filter === 'archived=1') {
            const queryParams = `archived=1&limit=${filters.limit}&page=${filters.page}`
            const fullUrl = `${url}?${queryParams}`

            this.props.kedo
                .api()
                .get(fullUrl)
                .then((response) => {
                    this.setState({
                        loading: false,
                        items: response.data.results,
                        pager: response.data.pager,
                    })
                })
                .catch((error) => {
                    this.setState({ loading: false })
                    console.info(error)
                })
        } else {
            this.props.kedo
                .api()
                .get(url, {
                    params: filters,
                })
                .then((response) => {
                    this.setState({
                        loading: false,
                        items: response.data.results,
                        pager: response.data.pager,
                    })
                })
                .catch((error) => {
                    this.setState({ loading: false })
                    console.info(error)
                })
        }
    }

    newIncomingMessagesCounter() {
        let url = this.props.kedo.api().getMessageEndpoint() + '/unread/count'
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .get(url, {}, false)
            .then((response) => {
                this.setState({
                    count: response.data.total,
                    loading: false,
                })
            })
            .catch((error) =>
                this.setState({
                    count: 0,
                    loading: false,
                })
            )
    }

    onChangePage(number) {
        this.setState({ page: number }, () =>
            this.fetchItems({ filter: this.state.filter })
        )
    }

    composeMessageToRecipient() {
        return (
            <ComposeMessage
                defaultMessage={''}
                disableTo={true}
                filter={this.state.filter}
                kedo={this.props.kedo}
                onCloseModal={() => this.setState({ composeTo: false })}
                to={[this.state.composeTo]}
            />
        )
    }

    hasId(props) {
        if (!props.match || !props.match.params) {
            return false
        }

        if (!props.match.params.id) {
            return false
        }

        return true
    }

    composeMessage() {
        if (this.state.compose && this.state.newMessage) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <ComposeMessage
                        defaultMessage={''}
                        filter={this.state.filter}
                        kedo={this.props.kedo}
                        onCloseModal={() => this.setState({ compose: false })}
                    />
                </Box>
            )
        } else {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <ComposeMessage
                        kedo={this.props.kedo}
                        to={[
                            {
                                id: this.state.message.sender_id,
                                sender_name: this.state.message.sender_name,
                            },
                        ]}
                        title={this.state.message.title}
                        dossierId={this.state.message.dossier_id}
                        filter={this.state.filter}
                        onCloseModal={() =>
                            this.setState({ compose: false, newMessage: false })
                        }
                    />
                </Box>
            )
        }
    }

    renderDetailMessage() {
        const urlObject = new URL(this.state.currentUrl)
        let id = urlObject.searchParams.get('id')

        if (!id && this.hasId(this.props)) {
            id = this.props.match.params.id
        }

        let item = this.state.items.find((item) => item.id === parseInt(id))

        return (
            <ReadMessage
                kedo={this.props.kedo}
                message={item ? item : null}
                id={id}
                filter={this.state.filter}
                goBack={() => this.fetchItems({ filter: this.state.filter })}
            />
        )
    }

    renderFiles() {
        const urlObject = new URL(this.state.currentUrl)
        const id = urlObject.searchParams.get('id')
        let item = this.state.items.find((item) => item.id === parseInt(id))

        if (!item || !item.files) {
            return null
        }
        let baseUrl = this.props.kedo.api().getBaseUrl()

        return (
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Box sx={{ mt: 2 }}>
                        {item.files.map((fileItem) => (
                            <StyledButton
                                key={fileItem.id}
                                target="_blank"
                                href={`${baseUrl}/file/${fileItem.id}/download`}
                                variant="outlined"
                                sx={{
                                    justifyContent: 'flex-start',
                                    '& svg': { ml: 1 },
                                }}
                            >
                                {fileItem.name}{' '}
                                <FontAwesomeIcon icon={faDownload} />
                            </StyledButton>
                        ))}
                    </Box>
                </Grid>
            </Grid>
        )
    }

    handleClose() {
        const urlWithoutParams =
            window.location.origin + window.location.pathname
        window.history.replaceState({}, document.title, urlWithoutParams)

        this.setState({ showAdditionalContent: false })
    }

    renderContent(status) {
        const urlParams = new URLSearchParams(window.location.search)
        const selectedItemId = urlParams.get('id')

        let settings = {
            ALLOWED_TAGS: [
                'b',
                'br',
                'span',
                'table',
                'ol',
                'tbody',
                'li',
                'i',
                'strong',
                'tr',
                'td',
                'thead',
                'div',
                'p',
                'h1',
                'h2',
            ],
            ALLOWED_ATTR: ['style', 'border'],
        }

        if (this.hasId(this.props)) {
            return <Box>{this.renderDetailMessage()}</Box>
        }

        return (
            <>
                <Box
                    className={`mainContainer messages ${
                        this.state.showAdditionalContent ? 'justifyBox' : ''
                    }`}
                >
                    <Box
                        className={` ${
                            this.state.showAdditionalContent
                                ? 'scrollMessages'
                                : ''
                        }`}
                        sx={{
                            display: {
                                xs: this.state.showAdditionalContent
                                    ? 'none'
                                    : 'block',
                                sm: 'block',
                            },
                        }}
                    >
                        {this.state.loading ? (
                            <LoadingData />
                        ) : (
                            <Box>
                                <Typography variant="h6" component="h3">
                                    {this.props.kedo.t(status)}
                                </Typography>
                                <MessagesHeader
                                    filter={this.state.filter}
                                    checked={this.state.checked}
                                    checkall={this.state.checkall}
                                    items={this.state.items}
                                    showAdditionalContent={
                                        this.state.showAdditionalContent
                                    }
                                    kedo={this.props.kedo}
                                    getButton={this.getButton}
                                    getCheckedItems={this.getCheckedItems}
                                    closeChangeReadStatus={
                                        this.closeChangeReadStatus
                                    }
                                    selectAll={this.selectAll}
                                    fetchItems={this.fetchItems}
                                    handleFilterChange={this.handleFilterChange}
                                    handleSearch={this.handleSearch}
                                    search={this.state.search}
                                    resetButton={this.resetButton}
                                />

                                {this.state.items.length <= 0 ? (
                                    <Alert
                                        severity="info"
                                        sx={{ textAlign: 'center' }}
                                    >
                                        {this.props.kedo.t('No messages found')}
                                    </Alert>
                                ) : (
                                    this.renderMessagesContent()
                                )}
                            </Box>
                        )}
                        {this.renderFooter()}
                    </Box>
                    {this.state.items.map(
                        (item) =>
                            parseInt(selectedItemId) === item.id && (
                                <>
                                    <Box
                                        className="messageContent"
                                        key={item.id}
                                        sx={{
                                            width: { xs: '100%', sm: '60%' },
                                        }}
                                    >
                                        <Box
                                            className="messageContainer"
                                            key={item.id}
                                        >
                                            <Typography
                                                variant="h6"
                                                component="h2"
                                                className="card-title-header"
                                            >
                                                {item.title}
                                                <Tooltip
                                                    title={this.props.kedo.t(
                                                        'Close'
                                                    )}
                                                >
                                                    <IconButton
                                                        onClick={
                                                            this.handleClose
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            size="xl"
                                                            icon={
                                                                faRectangleXmark
                                                            }
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                        </Box>
                                        <Box className="mainContainer">
                                            {item.dossier_id ? (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent:
                                                            'flex-end',
                                                    }}
                                                >
                                                    <Link
                                                        to={`/contentdossier/${item.dossier_id}`}
                                                    >
                                                        <StyledButton
                                                            sx={{
                                                                width: 40,
                                                                height: 40,
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faLink}
                                                            />
                                                        </StyledButton>
                                                    </Link>
                                                </Box>
                                            ) : null}
                                            <Box className="messageHeader">
                                                <Typography
                                                    variant="h6"
                                                    component="h2"
                                                    className="card-title"
                                                >
                                                    <Typography
                                                        component="strong"
                                                        sx={{ fontWeight: 600 }}
                                                    >
                                                        <Link
                                                            to={`/user/${item.sender_id}`}
                                                        >
                                                            {item.sender_name}
                                                        </Link>
                                                    </Typography>
                                                    <Box className="messageTo">
                                                        <Typography component="p">
                                                            {`${this.props.kedo.t(
                                                                'To'
                                                            )}: ${
                                                                item
                                                                    .recipients[0]
                                                                    .recipient_name
                                                            }`}
                                                        </Typography>
                                                        <Badge>
                                                            {this.props.kedo
                                                                .utils()
                                                                .dateFormat(
                                                                    item.created_at
                                                                )}
                                                        </Badge>
                                                    </Box>
                                                </Typography>
                                            </Box>
                                            <Box
                                                className="messageBody"
                                                sx={{
                                                    maxHeight: '80vh',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <Box
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(
                                                            item.message_text,
                                                            settings
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                            {this.renderFiles()}
                                            <StyledButton
                                                onClick={() =>
                                                    this.setState({
                                                        compose: true,
                                                    })
                                                }
                                                sx={{ mt: 1 }}
                                            >
                                                <Typography
                                                    component="span"
                                                    sx={{ mr: 2 }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faArrowTurnLeft}
                                                    />
                                                </Typography>

                                                <Typography component="span">
                                                    {this.props.kedo.t('Reply')}
                                                </Typography>
                                            </StyledButton>
                                        </Box>
                                    </Box>
                                </>
                            )
                    )}
                </Box>
            </>
        )
    }

    handleSearch(event) {
        if (event.key === 'Enter' || event.type === 'click') {
            event.preventDefault()
            this.setState(
                { search: this.state.search.toString() },
                this.fetchItems({ filter: this.state.filter })
            )
        }
    }

    handleFilterChange(event) {
        this.setState({
            search: event.target.value,
        })
    }

    resetSearch() {
        this.setState({ search: '', items: [] }, () => {
            this.fetchItems({ filter: this.state.filter })
        })
    }

    resetButton() {
        return (
            <StyledButton
                onClick={() => this.resetSearch()}
                sx={{ ml: '-40px', zIndex: 100 }}
            >
                <FontAwesomeIcon icon={faTimes} />
            </StyledButton>
        )
    }

    getCheckedItems() {
        let items = this.state.items
        let checked = this.state.checked

        return items.filter(function (item) {
            for (let i = 0; i < checked.length; i++) {
                if (item.id === checked[i]) {
                    return true
                }
            }
            return false
        })
    }

    getAndSetReadItem(itemId) {
        this.props.kedo
            .api()
            .get(this.props.kedo.api().getMessageEndpoint() + '/' + itemId)
            .then((response) => {
                this.setState({
                    message: response.data,
                })
                this.closeChangeReadStatus
            })
            .catch((error) => {
                throw error
            })
    }

    getButton() {
        let checkedItems = this.getCheckedItems()
        let read = true
        for (let i = 0; i < checkedItems.length; i++) {
            read = read && this.isRead(checkedItems[i])
        }

        if (read) {
            return (
                <Box sx={{ mt: 1 }}>
                    <MessagesReadstatus
                        kedo={this.props.kedo}
                        onClose={this.closeChangeReadStatus}
                        readStatus={true}
                        checked={this.state.checked}
                    />
                </Box>
            )
        }
        return (
            <Box sx={{ mt: 1 }}>
                <MessagesReadstatus
                    kedo={this.props.kedo}
                    onClose={this.closeChangeReadStatus}
                    readStatus={false}
                    checked={this.state.checked}
                />
            </Box>
        )
    }

    closeChangeReadStatus() {
        this.setState({ showAdditionalContent: false, checked: [] })
        this.fetchItems({ filter: 'incoming' })
    }

    hasCheckedItem(item) {
        let checked = this.state.checked
        checked = checked.find((checkItem) => checkItem === item.id)

        return checked
    }

    isRead(item) {
        for (let i = 0; i < item.recipients.length; i++) {
            if (item.recipients[i].read_date) {
                return true
            }
        }
        return false
    }

    selectAll(event) {
        let items = this.state.items

        if (true === event.target.checked) {
            this.setState({ checked: items.map((item) => item.id) })
        } else {
            this.setState({ checked: [] })
        }
    }

    updateCheckedStatus(event, item) {
        let checked = this.state.checked
        checked = checked.filter((checked) => checked !== item.id)

        if (event.target.checked === true) {
            checked.push(item.id)
        }

        this.setState({ checked: checked })
    }

    getBadges(item) {
        return (
            <MessageBadges
                item={item}
                kedo={this.props.kedo}
                showAdditionalContent={this.state.showAdditionalContent}
            />
        )
    }

    handleItemClick = (itemId) => {
        const isMobile = window.innerWidth <= 768

        if (isMobile) {
            this.props.history.push(`/messages/${itemId}`)
        } else {
            this.setState((prevState) => ({
                selectedItemId:
                    itemId === prevState.selectedItemId ? null : itemId,
                showAdditionalContent: true,
            }))
            this.getAndSetReadItem(itemId)
            const currentUrlParams = new URLSearchParams(window.location.search)
            currentUrlParams.set('id', itemId)
            const newUrl = `${
                window.location.pathname
            }?${currentUrlParams.toString()}`
            window.history.pushState({}, '', newUrl)
        }
    }

    renderMessagesContent() {
        return (
            <Box>
                {this.state.items.map((item) => {
                    return (
                        <MessageContent
                            key={item.id}
                            item={item}
                            filter={this.state.filter}
                            isUnread={
                                !item.read_date &&
                                this.state.filter !== 'outgoing'
                            }
                            kedo={this.props.kedo}
                            hasCheckedItem={(item) => this.hasCheckedItem(item)}
                            updateCheckedStatus={(event, item) =>
                                this.updateCheckedStatus(event, item)
                            }
                            handleItemClick={(id) => this.handleItemClick(id)}
                        />
                    )
                })}
            </Box>
        )
    }

    renderFooter() {
        return (
            <Grid container spacing={2} alignItems="center">
                <Grid size={12}>
                    <Pagination
                        pager={this.state.pager}
                        onChangePage={this.onChangePage}
                    />
                    <ItemCounter pager={this.state.pager} />
                </Grid>
            </Grid>
        )
    }

    setIncomingFilter() {
        window.scrollTo(0, 0)
        this.setState(
            {
                filter: 'incoming',
                page: 0,
                search: '',
                title: 'Inbox',
                showAdditionalContent: false,
            },
            () => this.fetchItems({ filter: 'incoming' })
        )
    }

    setOutgoingFilter() {
        window.scrollTo(0, 0)
        this.setState(
            {
                filter: 'outgoing',
                page: 0,
                search: '',
                title: 'Outgoing',
                showAdditionalContent: false,
            },
            () => this.fetchItems({ filter: 'outgoing' })
        )
    }

    archivedFilter() {
        window.scrollTo(0, 0)
        this.setState(
            {
                filter: 'archived=1',
                page: 0,
                search: '',
                title: 'Archived',
                showAdditionalContent: false,
            },
            () => this.fetchItems({ filter: 'archived=1' })
        )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.newIncomingMessagesCounter()
        }

        this.renderDetailMessage()
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search)
        const selectedItemId = urlParams.get('id')

        if (selectedItemId) {
            this.handleItemClick(selectedItemId)
        }

        this.newIncomingMessagesCounter()
        this.fetchItems({ filter: 'incoming' })
    }

    render() {
        return (
            <Box>
                {this.state.composeTo ? this.composeMessageToRecipient() : null}
                {this.state.compose ? this.composeMessage() : null}

                <Grid
                    container
                    spacing={2}
                    sx={{ justifyContent: 'space-between' }}
                >
                    {/* Sidebar */}
                    <Grid
                        size={{ xs: 12, md: 2 }}
                        className="messages_buttons sticky"
                    >
                        <Box
                            component="ul"
                            sx={{ listStyle: 'none', p: 0, m: 0 }}
                        >
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                {this.props.kedo.t('Messages')}
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid
                                    size={{ xs: 12, sm: 4, md: 12 }}
                                    className="colNewMessage"
                                >
                                    <Button
                                        sx={{
                                            justifyContent: 'flex-start',
                                            textTransform: 'none',
                                        }}
                                        fullWidth
                                        className="button btn-primary sendMessage"
                                        onClick={() =>
                                            this.setState({
                                                compose: true,
                                                newMessage: true,
                                            })
                                        }
                                    >
                                        <FontAwesomeIcon icon={faEnvelope} />
                                        &nbsp;{' '}
                                        {this.props.kedo.t('New message')}
                                    </Button>
                                </Grid>

                                <Grid size={12}>
                                    <Link to="/messages">
                                        <Grid container spacing={1}>
                                            <Grid
                                                size={{ xs: 12, sm: 4, md: 12 }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    sx={(theme) => ({
                                                        justifyContent:
                                                            'flex-start',
                                                        textTransform: 'none',
                                                        color: theme.palette
                                                            .text.primary,
                                                        fontWeight: 'normal',
                                                        backgroundColor:
                                                            'rgb(178, 213, 237)',
                                                        '&:hover': {
                                                            color: theme.palette
                                                                .text.primary,
                                                            backgroundColor:
                                                                'rgb(178, 213, 237)',
                                                        },
                                                        '& .MuiBadge-badge': {
                                                            backgroundColor:
                                                                theme.palette
                                                                    .common
                                                                    .white,
                                                            color: theme.palette
                                                                .text.primary,
                                                            ml: 'auto',
                                                            mr: 1,
                                                            mt: 0.5,
                                                        },
                                                    })}
                                                    fullWidth
                                                    className="mailBoxNotify"
                                                    onClick={
                                                        this.setIncomingFilter
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faInbox}
                                                    />
                                                    &nbsp;{' '}
                                                    {this.props.kedo.t('Inbox')}
                                                    &nbsp;
                                                    <Badge
                                                        className={'badge'}
                                                        badgeContent={
                                                            this.state.count
                                                        }
                                                        sx={{
                                                            ml: 'auto',
                                                            mr: 1,
                                                            color: 'black',
                                                            '& .MuiBadge-badge':
                                                                {
                                                                    backgroundColor:
                                                                        'white',
                                                                },
                                                        }}
                                                    />
                                                </Button>
                                            </Grid>

                                            <Grid
                                                size={{ xs: 12, sm: 4, md: 12 }}
                                            >
                                                <Button
                                                    sx={{
                                                        justifyContent:
                                                            'flex-start',
                                                        textTransform: 'none',
                                                        color: 'black',
                                                        fontWeight: 'normal',
                                                        backgroundColor:
                                                            '#DCECF7',
                                                    }}
                                                    fullWidth
                                                    className="mailBox"
                                                    onClick={
                                                        this.setOutgoingFilter
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faPaperPlane}
                                                    />
                                                    &nbsp;{' '}
                                                    {this.props.kedo.t(
                                                        'Outgoing'
                                                    )}
                                                </Button>
                                            </Grid>

                                            <Grid
                                                size={{ xs: 12, sm: 4, md: 12 }}
                                            >
                                                <Button
                                                    sx={{
                                                        justifyContent:
                                                            'flex-start',
                                                        textTransform: 'none',
                                                        color: 'black',
                                                        fontWeight: 'normal',
                                                        backgroundColor:
                                                            '#DCECF7',
                                                    }}
                                                    fullWidth
                                                    className="mailBox"
                                                    onClick={
                                                        this.archivedFilter
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faFolderOpen}
                                                    />
                                                    &nbsp;{' '}
                                                    {this.props.kedo.t(
                                                        'Archived'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ height: 16 }} />
                    </Grid>

                    {/* Main content */}
                    <Grid
                        size={{ xs: 12, md: 10 }}
                        sx={{ flexDirection: 'column' }}
                    >
                        {this.renderContent(this.state.title)}
                    </Grid>
                </Grid>
            </Box>
        )
    }
}

export default MessagesOverview
